import type { TextFieldProps } from '@mui/material/TextField';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import React from 'react';

export interface TextareaProps extends Omit<TextFieldProps, 'variant'> {}

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& textarea': {
    maxHeight: theme.spacing(25),
    minHeight: theme.spacing(3.75),
    marginTop: theme.spacing(1),
  },
  '& .MuiOutlinedInput-root': {
    fontSize: theme.spacing(1.75),
  },
}));

const Textarea: React.FC<TextareaProps> = ({ ...props }) => (
  <StyledTextField
    variant="outlined"
    multiline
    {...props}
    {...(props.label && { InputLabelProps: { shrink: true } })}
  />
);

export default Textarea;
